export const RANKINGS = [
  { rank:1,  name:"Argentina",       flag:"🇦🇷", points:1896 },
  { rank:2,  name:"Spain",           flag:"🇪🇸", points:1876 },
  { rank:3,  name:"France",          flag:"🇫🇷", points:1849 },
  { rank:4,  name:"England",         flag:"🏴󠁧󠁢󠁥󠁮󠁧󠁿", points:1812 },
  { rank:5,  name:"Portugal",        flag:"🇵🇹", points:1793 },
  { rank:6,  name:"Brazil",          flag:"🇧🇷", points:1782 },
  { rank:7,  name:"Netherlands",     flag:"🇳🇱", points:1756 },
  { rank:8,  name:"Germany",         flag:"🇩🇪", points:1744 },
  { rank:9,  name:"Colombia",        flag:"🇨🇴", points:1731 },
  { rank:10, name:"Italy",           flag:"🇮🇹", points:1728 },
  { rank:11, name:"Belgium",         flag:"🇧🇪", points:1716 },
  { rank:12, name:"Croatia",         flag:"🇭🇷", points:1703 },
  { rank:13, name:"Uruguay",         flag:"🇺🇾", points:1695 },
  { rank:14, name:"Mexico",          flag:"🇲🇽", points:1681 },
  { rank:15, name:"Morocco",         flag:"🇲🇦", points:1673 },
  { rank:16, name:"Switzerland",     flag:"🇨🇭", points:1664 },
  { rank:17, name:"USA",             flag:"🇺🇸", points:1658 },
  { rank:18, name:"Denmark",         flag:"🇩🇰", points:1645 },
  { rank:19, name:"Japan",           flag:"🇯🇵", points:1638 },
  { rank:20, name:"Ecuador",         flag:"🇪🇨", points:1629 },
  { rank:21, name:"Senegal",         flag:"🇸🇳", points:1617 },
  { rank:22, name:"Turkey",          flag:"🇹🇷", points:1608 },
  { rank:23, name:"Austria",         flag:"🇦🇹", points:1598 },
  { rank:24, name:"Iran",            flag:"🇮🇷", points:1587 },
  { rank:25, name:"South Korea",     flag:"🇰🇷", points:1576 },
  { rank:26, name:"Wales",           flag:"🏴󠁧󠁢󠁷󠁬󠁳󠁿", points:1567 },
  { rank:27, name:"Australia",       flag:"🇦🇺", points:1558 },
  { rank:28, name:"Ukraine",         flag:"🇺🇦", points:1549 },
  { rank:29, name:"Hungary",         flag:"🇭🇺", points:1541 },
  { rank:30, name:"Canada",          flag:"🇨🇦", points:1532 },
  { rank:31, name:"Poland",          flag:"🇵🇱", points:1524 },
  { rank:32, name:"Serbia",          flag:"🇷🇸", points:1515 },
  { rank:33, name:"Peru",            flag:"🇵🇪", points:1507 },
  { rank:34, name:"Egypt",           flag:"🇪🇬", points:1498 },
  { rank:35, name:"Czech Republic",  flag:"🇨🇿", points:1489 },
  { rank:36, name:"Ivory Coast",     flag:"🇨🇮", points:1481 },
  { rank:37, name:"Chile",           flag:"🇨🇱", points:1472 },
  { rank:38, name:"Algeria",         flag:"🇩🇿", points:1464 },
  { rank:39, name:"Sweden",          flag:"🇸🇪", points:1455 },
  { rank:40, name:"Norway",          flag:"🇳🇴", points:1447 },
  { rank:41, name:"Venezuela",       flag:"🇻🇪", points:1438 },
  { rank:42, name:"Scotland",        flag:"🏴󠁧󠁢󠁳󠁣󠁴󠁿", points:1430 },
  { rank:43, name:"Nigeria",         flag:"🇳🇬", points:1421 },
  { rank:44, name:"Ghana",           flag:"🇬🇭", points:1413 },
  { rank:45, name:"Slovenia",        flag:"🇸🇮", points:1404 },
  { rank:46, name:"Romania",         flag:"🇷🇴", points:1396 },
  { rank:47, name:"Greece",          flag:"🇬🇷", points:1387 },
  { rank:48, name:"Paraguay",        flag:"🇵🇾", points:1379 },
  { rank:49, name:"Saudi Arabia",    flag:"🇸🇦", points:1370 },
  { rank:50, name:"South Africa",    flag:"🇿🇦", points:1362 },
  { rank:51, name:"Bolivia",         flag:"🇧🇴", points:1354 },
  { rank:52, name:"Cameroon",        flag:"🇨🇲", points:1345 },
  { rank:53, name:"Qatar",           flag:"🇶🇦", points:1329 },
  { rank:54, name:"Slovakia",        flag:"🇸🇰", points:1320 },
  { rank:55, name:"Albania",         flag:"🇦🇱", points:1312 },
  { rank:56, name:"Tunisia",         flag:"🇹🇳", points:1303 },
  { rank:57, name:"Finland",         flag:"🇫🇮", points:1286 },
  { rank:58, name:"Panama",          flag:"🇵🇦", points:1278 },
  { rank:59, name:"Costa Rica",      flag:"🇨🇷", points:1269 },
  { rank:60, name:"Jordan",          flag:"🇯🇴", points:1261 },
  { rank:61, name:"Mali",            flag:"🇲🇱", points:1253 },
  { rank:62, name:"Iraq",            flag:"🇮🇶", points:1244 },
  { rank:63, name:"Cape Verde",      flag:"🇨🇻", points:1236 },
  { rank:64, name:"Honduras",        flag:"🇭🇳", points:1227 },
  { rank:65, name:"Bosnia",          flag:"🇧🇦", points:1219 },
  { rank:66, name:"Montenegro",      flag:"🇲🇪", points:1210 },
  { rank:67, name:"Burkina Faso",    flag:"🇧🇫", points:1202 },
  { rank:68, name:"Jamaica",         flag:"🇯🇲", points:1193 },
  { rank:69, name:"UAE",             flag:"🇦🇪", points:1185 },
  { rank:70, name:"Guinea",          flag:"🇬🇳", points:1176 },
  { rank:71, name:"DR Congo",        flag:"🇨🇩", points:1168 },
  { rank:72, name:"El Salvador",     flag:"🇸🇻", points:1159 },
  { rank:73, name:"North Macedonia", flag:"🇲🇰", points:1151 },
  { rank:74, name:"Uzbekistan",      flag:"🇺🇿", points:1143 },
  { rank:75, name:"Iceland",         flag:"🇮🇸", points:1134 },
  { rank:76, name:"Zambia",          flag:"🇿🇲", points:1126 },
  { rank:77, name:"Congo",           flag:"🇨🇬", points:1117 },
  { rank:78, name:"Cuba",            flag:"🇨🇺", points:1109 },
  { rank:79, name:"Mozambique",      flag:"🇲🇿", points:1098 },
  { rank:80, name:"Tanzania",        flag:"🇹🇿", points:1087 },
];
